import { Close, Download, OpenInNew } from "@mui/icons-material";
import { Box, Button, Stack, Switch, Typography } from "@mui/material";
import React from "react";
import { useDispatchWrapper } from "../../../../../hooks";
import { showMessage } from "../../../../../redux/messages/messagesActions";
import { RightPanel } from "../../../../../components/RightPanel";
import { PageLoader } from "../../../../../components/PageLoader/PageLoader";
import {
	fetchRoughEstimateDownloadPdfAsync,
	fetchRoughEstimatePreviewAsync,
} from "../../../../../redux/leads/leadsActions";
import {
	fetchPaymentDownloadPdfAsync,
	fetchPaymentPreviewAsync,
} from "../../../../../redux/paymentDetails/paymentDetailsActions";

interface IPaymentPreviewProps {
	open: boolean;
	UUID: string;
	onClose: () => void;
}
export const PaymentPreview: React.FC<IPaymentPreviewProps> = (props) => {
	const { open, UUID, onClose } = props;
	const [loading, setLoading] = React.useState(false);
	const [htmlContent, setHtmlContent] = React.useState("");

	const [isIndianStyle, setIsIndianStyle] = React.useState<boolean>(true);

	const dispatch = useDispatchWrapper();

	const fetchPreview = async () => {
		setLoading(true);
		dispatch(
			fetchPaymentPreviewAsync(UUID, "PREVIEW", (isSuccess, html) => {
				if (isSuccess && html) {
					setHtmlContent(html);
				}
				setLoading(false);
			})
		);
	};

	const handleDownloadPdf = async () => {
		dispatch(
			fetchPaymentDownloadPdfAsync(UUID, "PDF", (isSuccess) => {
				if (isSuccess) {
					console.log("PDF downloaded successfully");
				}
			})
		);
	};

	const handleOpenInNewTab = () => {
		const newWindow = window.open();
		if (newWindow) {
			newWindow.document.write(htmlContent);
		}
	};

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(
				`${window.location.host}/public/credit_debit_note/${UUID}`
			);
			dispatch(
				showMessage({
					displayAs: "snackbar",
					message: "Link Copied!",
					type: "success",
				})
			);
		} catch (error) {
			dispatch(
				showMessage({
					displayAs: "snackbar",
					message: "Something went to be wrong!",
					type: "error",
				})
			);
		}
	};

	React.useEffect(() => {
		fetchPreview();
	}, [isIndianStyle]);

	return (
		<>
			<RightPanel
				heading={"Payment Preview"}
				open={open}
				onClose={onClose}
				width="50%"
				actionButtons={() => {
					return (
						<Stack
							direction={"row"}
							justifyContent={"space-between"}
							spacing={2}
						>
							<Stack
								direction={"row"}
								spacing={2}
							>
								<Button
									variant="contained"
									onClick={onClose}
								>
									<Close sx={{ fontSize: 18, mr: 0.5 }} />
									Close
								</Button>
							</Stack>
							<Stack
								direction={"row"}
								spacing={2}
							>
								<Button
									variant="contained"
									onClick={handleDownloadPdf}
									disabled={!htmlContent} // Disable download if no content
								>
									<Download sx={{ fontSize: 18, mr: 0.5 }} />
									Download
								</Button>
							</Stack>
						</Stack>
					);
				}}
			>
				<PageLoader loading={loading}>
					{htmlContent ? (
						<div dangerouslySetInnerHTML={{ __html: htmlContent }} />
					) : (
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								justifyContent: "center",
								height: "100%",
								textAlign: "center",
								p: 4,
							}}
						>
							<Typography
								variant="h6"
								color="textSecondary"
							>
								Sorry, there is no estimation data available.
							</Typography>
							{/* <Button
                                variant="outlined"
                                sx={{ mt: 2 }}
                                onClick={onClose}
                            >
                                Close Preview
                            </Button> */}
						</Box>
					)}
				</PageLoader>
			</RightPanel>
		</>
	);
};
